import { render, staticRenderFns } from "./DemoGuideMenu.vue?vue&type=template&id=556df398&scoped=true&"
import script from "./DemoGuideMenu.vue?vue&type=script&lang=js&"
export * from "./DemoGuideMenu.vue?vue&type=script&lang=js&"
import style0 from "./DemoGuideMenu.vue?vue&type=style&index=0&id=556df398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556df398",
  null
  
)

export default component.exports